import { render, staticRenderFns } from "./PassMultipleDialog.vue?vue&type=template&id=bcd9511c&scoped=true"
import script from "./PassMultipleDialog.vue?vue&type=script&lang=js"
export * from "./PassMultipleDialog.vue?vue&type=script&lang=js"
import style0 from "./PassMultipleDialog.vue?vue&type=style&index=0&id=bcd9511c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd9511c",
  null
  
)

export default component.exports